import React from "react";
import {observer} from "mobx-react";
import {toJS} from "mobx";
import {Card, Button, Select, Tabs, Table, Modal, Tag, Row, Col,Alert} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import  UserService from "../../services/User"
import Space from "../common/UI/Space";
import * as _ from "lodash"
const {Option}=Select;
const {CheckableTag} = Tag;
const {Meta}=Card;
const {TabPane} = Tabs;
require('./ReportBoxes.css');
const types={
    'text':'PDF',
    'image':"图片",
    "file":"文件",
    "quick":"小程序",
    "step":"任务"
}

export default @observer
class ReportBoxes extends React.Component {
    render() {
        const {store} = this.props;
        const boxTags=toJS(store.boxTags);
        const allowedBoxes=toJS(store.allowJoinBoxes);
        const user=UserService.getCurrentUserName();
        const groupedSelectedBoxes = toJS(store.groupedSelectedBoxes);
        var unArchivedBoxes = groupedSelectedBoxes['unArchived'];
        var archivedBoxes = groupedSelectedBoxes['archived'];
        const teachers=store.teachers;
        const columns_join = [
            {
                title: '作业箱名称',
                dataIndex: 'name',
            },
            {
                title: '教师',
                dataIndex: 'teacher',
            },
            {
                title: '操作',
                dataIndex: 'action',
                render:(action,record)=> {
                    const students=record.students||[];
                    const isJoin=_.includes(students,user);
                    return <Button type="primary" onClick={()=>store.joinOrQuitReportBox(isJoin,record)}>{isJoin?"退出":"加入"}</Button>
                }

            },
        ];
        return (<>
            <div style={{width:"100%",margin:"0,auto"}}>
            {/* <Button icon={<PlusOutlined />} onClick={store.showModal} >加入作业箱</Button> */}
            <span style={{float: "right"}}>
                {boxTags.map(tag => (
                    <CheckableTag
                        key={tag}
                        style={{border: "1px solid #dcdcdc", borderRadius: "2px"}}
                        checked={store.selectedTags.indexOf(tag) > -1}
                        onChange={checked => store.selectTag(tag, checked)}
                    >
                        {tag}
                    </CheckableTag>
                ))}
                </span>
                <Space/>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="未归档" key="1">
                        {unArchivedBoxes.length===0?<div>
                            <img src={'./img/box.png'} style={{width:'220px',float:"left"}}/>
                            <div style={{float:'left',fontSize:20,marginLeft:60,height:'240px',lineHeight:'200px',width:420}}>
                                你现在尚未加入任何作业箱，请联系老师加入!
                            </div>

                        </div>:<Row gutter={[16, 16]}>
                            {unArchivedBoxes.map(box => {
                                const colors=box.colors||{};
                                const leftColor = colors.left || "#2a9bff";
                                const rightColor = colors.right || "#534AFD";
                                const resource = box.resource;
                                return <Col key={box._id}>
                                    <Card
                                        style={{width: 290, height: 280}}
                                        cover={
                                            <a href={box.reportType==="step"?`#/s/report/box_step/${box._id}`:`#/s/report/box/${box._id}`}>
                                                {resource ?
                                                    <img src={resource.url} style={{height: 175, width: "100%"}}/> :
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: '100%',
                                                        height: 175,
                                                        background: `-webkit-linear-gradient(135deg,${leftColor},${rightColor})`
                                                    }}>
                                                        <p className={'font_style'}>{box.name}</p>
                                                    </div>}
                                            </a>
                                        }
                                    >
                                        <Meta
                                            title={<Row>
                                                <Col span={22} style={{
                                                    overflow: "hidden",
                                                    textOverflow: 'ellipsis'
                                                }}>{box.name}</Col>
                                            </Row>}
                                             description={<div>
                                                作业类型：{types[box.reportType]}
                                                </div>}
                                        />
                                    </Card>
                                </Col>
                            })}
                        </Row>}
                    </TabPane>
                    <TabPane tab="已归档" key="2">
                        <Alert message="已归档的作业箱不可提交作业！" type="warning" showIcon />
                        <Space/>
                        <Row gutter={[16, 16]}>
                            {archivedBoxes.map(box => {
                                const colors=box.colors||{};
                                const leftColor = colors.left || "#2a9bff";
                                const rightColor = colors.right || "#534AFD";
                                const resource = box.resource;
                                return <Col key={box._id}>
                                    <Card
                                        style={{width: 290, height: 240}}
                                        cover={
                                            <a href={box.reportType==="step"?`#/s/report/box_step/${box._id}`:`#/s/report/box/${box._id}`}>
                                                {resource ?
                                                    <img src={resource.url} style={{height: 175, width: "100%"}}/> :
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: '100%',
                                                        height: 175,
                                                        background: `-webkit-linear-gradient(135deg,${leftColor},${rightColor})`
                                                    }}>
                                                        <p className={'font_style'}>{box.name}</p>
                                                    </div>}
                                            </a>
                                        }
                                    >
                                        <Meta
                                            title={<Row>
                                                <Col span={22} style={{
                                                    overflow: "hidden",
                                                    textOverflow: 'ellipsis'
                                                }}>{box.name}</Col>
                                            </Row>}
                                            description={<div>
                                                作业类型：{types[box.reportType]}
                                                </div>}
                                        />
                                    </Card>
                                </Col>
                            })}
                        </Row>
                    </TabPane>
                </Tabs>
            </div>
            <Modal title="开放加入的作业箱"
                   visible={store.isModalVisible}
                   footer={null}
                   onOk={()=>store.isModalVisible=false}
                   onCancel={()=>store.isModalVisible=false}>
                <div>
                    <Select
                        allowClear
                        showSearch
                        style={{ minWidth: 300 }}
                        placeholder="教师姓名"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={store.selectTeacher}
                    >
                        {teachers.map(teacher=><Option key={teacher.username} value={teacher.username}>{teacher.showName}</Option>)}
                    </Select>
                <Table columns={columns_join} dataSource={allowedBoxes} rowKey="_id"/>
                </div>
            </Modal>
        </>);
    }
}